// artistAccordion.js

export function mountArtistAccordion({ root = document } = {}) {
  const SEL_BTN = '[data-accordion-btn]';
  const SEL_PANEL = '[data-accordion-panel]';

  function getPanelState(btn, scope) {
    const panelId = btn.getAttribute('aria-controls');
    if (!panelId) return null;

    const panel = scope.querySelector(`#${panelId}`);
    if (!panel) return null;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';

    return { panel, isOpen };
  }

  function closeAll(scope) {
    scope.querySelectorAll(SEL_BTN).forEach((b) => {
      b.classList.remove('active');
      b.setAttribute('aria-expanded', 'false');
    });

    scope.querySelectorAll(SEL_PANEL).forEach((p) => {
      p.classList.remove('open');
    });
  }

  function open(btn, panel) {
    btn.classList.add('active');
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('open');
  }

  function toggle(btn) {
    const scope = btn.closest('.story-modal') || root;
    const state = getPanelState(btn, scope);
    if (!state) return;

    const { panel, isOpen } = state;

    closeAll(scope);

    if (!isOpen) {
      open(btn, panel);
    }
  }

  function onClick(e) {
    const btn = e.target.closest(SEL_BTN);
    if (!btn || !root.contains(btn)) return;

    e.preventDefault();
    e.stopPropagation();

    toggle(btn);
  }

  root.addEventListener('click', onClick, true);

  function destroy() {
    root.removeEventListener('click', onClick, true);
  }

  return { destroy, closeAll };
}
